import { Organization } from '@teammood/shared/util/core';
import { IntercomService } from '@teammood/shared/util/intercom';
import { OrganizationService } from './organization.service';
import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { TranslateService } from "@ngx-translate/core";
import { catchError, EMPTY, filter, from, mergeMap, Subject, switchMap, takeUntil, tap } from "rxjs";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TmValidators } from "@teammood/shared/util/form";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "organization-settings",
    templateUrl: "organization-settings.component.html",
    providers: [
        OrganizationService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrganizationSettingsComponent implements OnInit, OnDestroy {

    protected retentions: { label: string; value: number; }[];
    protected organization: Organization;
    protected alert: {
        show: boolean,
        style: string,
        message: string
    };

    protected form: FormGroup = new FormGroup({
        name: new FormControl<string>('', [TmValidators.required, Validators.minLength(2)]),
        retention: new FormControl<number>(-1, [Validators.required]),
    });

    private _destroy$ = new Subject<void>();

    constructor(
        private logger: LoggerService,
        private translate: TranslateService,
        private organizationService: OrganizationService,
        private intercomService: IntercomService,
        private snackBarService: SnackBarService,
        private route: ActivatedRoute,
    ) {
    }

    ngOnInit() {
        const monthsLabel = this.translate.instant('months');
        this.retentions = [{
            label: 'Off',
            value: -1
        }, {
            label: '48 ' + monthsLabel,
            value: 48
        }, {
            label: '36 ' + monthsLabel,
            value: 36
        }, {
            label: '24 ' + monthsLabel,
            value: 24
        }, {
            label: '12 ' + monthsLabel,
            value: 12
        }, {
            label: '6 ' + monthsLabel,
            value: 6
        }];

        this.route.params.pipe(
            filter(params => !!params['id']),
            mergeMap(params => {
                return from(this.init(params['id']));
            }),
            takeUntil(this._destroy$)
        ).subscribe();


    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    private async init(orgId: string){

        this.organizationService.get(orgId).pipe(
            tap(org => {
                this.organization = org;
                this.form.reset(org);
            }),
            catchError(err => {
                this.logger.error(err);
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    async updateOrg() {

        this.organization = {
            ...this.organization,
            name: this.form.get('name').value,
            retention: this.form.get('retention').value,
        };

        this.organizationService.update(this.organization.id, this.organization).pipe(
            tap(response => {
                this.snackBarService.success(response.message);
                this.logger.info(response);
            }),
            switchMap(response => {
                //Reload organization data
                return this.organizationService.get(response.newOrgId).pipe(
                    tap(organization => {
                        this.organization = organization;
                        this.form.reset(organization);
                    })
                );
            }),
            catchError(error => {
                this.logger.error(error);
                this.alert = {
                    show: true,
                    style: "alert-danger",
                    message: error.data
                };
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    contact_us() {
        this.intercomService.open_chat();
    }
}